// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-44fccccc]{margin-top:20px;padding:30px 20px;background-color:#fff;border-radius:3px}.content[data-v-44fccccc],.field[data-v-44fccccc]{display:flex;flex-direction:column}.field[data-v-44fccccc]{margin-bottom:20px;max-width:680px}.label[data-v-44fccccc]{margin-bottom:10px;color:#000;font-weight:600;line-height:1.21429rem}", ""]);
// Exports
module.exports = exports;
